import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

export default () => {
  const fetch = useFetch()

  const fetchResourceFiles = async (eventId) => {
    return apiWrapper({
      fetch,
      url: `events/event/resourceFiles?eventId=${eventId}`,
      options: {
        method: 'GET'
      }
    });
  }

  const uploadResourceFiles = async (eventId, files) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file);
    });
    formData.append('eventId', eventId);

    return apiWrapper({
      fetch,
      url: `file/upload/resourceFiles`,
      options: {
        method: 'POST',
        body: formData
      }
    });
  }

  return {
    fetchResourceFiles,
    uploadResourceFiles
  }
}
